import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useCategoryList(props) {
  const { companyId } = useApp();
  const { data, isLoading } = useList(
    'company/getEmployeeCategories',
    { company_id: companyId, ...props?.params },
    '',
    'v1',
  );
  return {
    data: data?.data?.data,
    isLoading,
    count: data?.data?.total || data?.data?.data?.length,
  };
}
